import { Controller, Control } from 'react-hook-form';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';

interface BooleanRadioButtonGroupProps {
  name: string;
  control: Control<any>;
  trueText: string;
  trueHelperText?: string;
  falseText: string;
  falseHelperText?: string;
  disabled?: boolean;
}

export default function BooleanRadioButtonGroup({
  name,
  control,
  trueText,
  trueHelperText,
  falseText,
  falseHelperText,
  disabled = false,
}: BooleanRadioButtonGroupProps) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <RadioGroup
          className="boolean-radio-group"
          defaultValue={false}
          name={`rdo-${name}`}
          value={field.value}
          onChange={(_e, value) => {
            if (value !== null) {
              field.onChange(value == 'true' ? true : false);
            }
          }}>
          <div className="radio-item">
            <FormControlLabel
              value={true}
              control={<Radio disabled={disabled} />}
              label={trueText}
            />
            {trueHelperText && (
              <span className="radio-helper-text">{trueHelperText}</span>
            )}
          </div>
          <div className="radio-item">
            <FormControlLabel
              value={false}
              control={<Radio disabled={disabled} />}
              label={falseText}
            />
            {falseHelperText && (
              <span className="radio-helper-text">{falseHelperText}</span>
            )}
          </div>
        </RadioGroup>
      )}
    />
  );
}
